import {
    AdLabel, Ads,
    AdsFilter, Campaign,
    CampaignsFilter,
    Organization,
    OrganizationsFilter, Profile, SampleUsers,
} from "./types";
import {createAction, createAsyncAction} from "typesafe-actions";
import {IFeed, SampleFeedRow} from "../feed/types";

export const fetchOrganizationsAsyncActions = createAsyncAction(
    'FETCH_ORGANIZATIONS_REQUEST',
    'FETCH_ORGANIZATIONS_SUCCESS',
    'FETCH_ORGANIZATIONS_FAILURE'
)<{}, { organizations: Organization[] }, { error: Error }>();

export const fetchCampaignsByOrganizationIdAsyncActions = createAsyncAction(
    'FETCH_CAMPAIGNS_BY_ORGANIZATION_ID_REQUEST',
    'FETCH_CAMPAIGNS_BY_ORGANIZATION_ID_SUCCESS',
    'FETCH_CAMPAIGNS_BY_ORGANIZATION_ID_FAILURE'
)<{ organizationId: string }, { campaigns: Campaign[], organizationId: string }, { error: Error }>();

export const fetchAdLabelsByOrganizationIdAsyncActions = createAsyncAction(
    'FETCH_AD_LABELS_BY_ORGANIZATION_ID_REQUEST',
    'FETCH_AD_LABELS_BY_ORGANIZATION_ID_SUCCESS',
    'FETCH_AD_LABELS_BY_ORGANIZATION_ID_FAILURE'
)<{ organizationId: string }, { adLabels: AdLabel[], organizationId: string }, { error: Error }>();


export const fetchFeedsByOrganizationIdAsyncActions = createAsyncAction(
    'FETCH_FEEDS_BY_ORGANIZATION_ID_REQUEST',
    'FETCH_FEEDS_BY_ORGANIZATION_ID_SUCCESS',
    'FETCH_FEEDS_BY_ORGANIZATION_ID_FAILURE'
)<{ organizationId: string }, { feeds: IFeed[], organizationId: string }, { error: Error }>();


export const fetchFeedPreviewAsyncActions = createAsyncAction(
    'FETCH_FEED_PREVIEW_REQUEST',
    'FETCH_FEED_PREVIEW_SUCCESS',
    'FETCH_FEED_PREVIEW_FAILURE'
)<{ feedId: string }, { preview: SampleFeedRow[], feedId: string }, { error: Error }>();


export const filterAdsAsyncActions = createAsyncAction(
    'FILTER_ADS_REQUEST',
    'FILTER_ADS_SUCCESS',
    'FILTER_ADS_FAILURE'
)<{
    organizationId: string,
    campaignIds: string[],
    status: string
}, { ads: Ads[] }, { error: Error }>();


export const fetchForecastsAsyncActions = createAsyncAction(
    'FETCH_FORECASTS_REQUEST',
    'FETCH_FORECASTS_SUCCESS',
    'FETCH_FORECASTS_FAILURE'
)<{ campaignId: string }, { sampleUsers: SampleUsers[] }, { error: Error }>();


export const fetchAudiUsersAsyncActions = createAsyncAction(
    'FETCH_AUDI_USERS_REQUEST',
    'FETCH_AUDI_USERS_SUCCESS',
    'FETCH_AUDI_USERS_FAILURE'
)<{ ids: string[] }, { profiles: Profile[] }, { error: Error }>();


export interface ISetActiveOrganizationIdWithActiveCampaignIdActionPayload {
    organizationId: string,
    campaignId: string
}

export const setActiveOrganizationIdWithActiveCampaignIdAction = createAction(
    'SET_ACTIVE_ORGANIZATION_ID_WITH_ACTIVE_CAMPAIGN_ID',
    action => {
        return (params: ISetActiveOrganizationIdWithActiveCampaignIdActionPayload) => action(params);
});

export interface ISetActiveOrganizationIdActionPayload {
    organizationId: string,
}

export const setActiveOrganizationIdAction = createAction(
    'SET_ACTIVE_ORGANIZATION_ID',
    action => {
        return (params: ISetActiveOrganizationIdActionPayload) => action(params);
    });

export interface ISetActiveCampaignIdsActionPayload {
    campaignIds: string[],
}

export const setActiveCampaignIdsAction = createAction(
    'SET_ACTIVE_CAMPAIGN_ID',
    action => {
        return (params: ISetActiveCampaignIdsActionPayload) => action(params);
    });


export interface ISetActiveAdsIdActionPayload {
    adsId: string,
}

export const setActiveAdsIdAction = createAction(
    'SET_ACTIVE_ADS_ID',
    action => {
        return (params: ISetActiveAdsIdActionPayload) => action(params);
    });


export interface ISetOrganizationsFilterActionPayload {
    filter: OrganizationsFilter,
}

export const setOrganizationsFilterAction = createAction(
    'SET_ORGANIZATIONS_FILTER',
    action => {
        return (params: ISetOrganizationsFilterActionPayload) => action(params);
    });


export interface ISetCampaignsFilterActionPayload {
    filter: CampaignsFilter,
}

export const setCampaignsFilterAction = createAction(
    'SET_CAMPAIGNS_FILTER',
    action => {
        return (params: ISetCampaignsFilterActionPayload) => action(params);
    });


export interface ISetAdsFilterActionPayload {
    filter: AdsFilter,
}

export const setAdsFilterAction = createAction(
    'SET_ADS_FILTER',
    action => {
        return (params: ISetAdsFilterActionPayload) => action(params);
    });
